import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";

export const openedInterventionDto = z.object({
  hasReachedMaxInterventionLimit: z.boolean(),
  maxAllowedOpenedIntervention: z.number(),
  openedIntervention: z.array(
    z.object({
      siteId: branded.siteId,
      openedFolders: z.number(),
    }),
  ),
});

export type TOpenedInterventionDto = z.infer<typeof openedInterventionDto>;
